import React from 'react';
import * as mobxReact from 'mobx-react';
import { IConfigurationFilter, ISelectableFilter } from '../../../../../api/reports.dao';
import FilterPill from '../filter-pill/filter-pill';

export interface IProps {
    filter: IConfigurationFilter;
    firstSelectedDate: Date | null;
    lastSelectedDate: Date | null;
    availableDates: { dateNumber: number; dateToRender: string }[];
    clear: (filter: ISelectableFilter) => void;
    select: (filter: ISelectableFilter) => void;
    isSelected: boolean;
    availableFilterTypes: ISelectableFilter[];
}

const DateFilterPill = mobxReact.observer((props: IProps) => {
    const {
        firstSelectedDate,
        lastSelectedDate,
        ...rest
    } = props;

    let dateLabel = '';

    if (firstSelectedDate) {
        dateLabel = firstSelectedDate.toDateString();
    }
    if (lastSelectedDate && lastSelectedDate.getTime() !== firstSelectedDate.getTime()) {
        dateLabel += ` - ${lastSelectedDate.toDateString()}`;
    }

    return <FilterPill customText={dateLabel} {...rest} />;
});

export default DateFilterPill;
